import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import { Card, CardBody, Row, Col, Label, Button, Alert } from "reactstrap";

import makeAnimated from "react-select/lib/animated";

import { sucursalesFetch } from "../../redux/actions/aRamos";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchConsultarIdentificacionAP } from "../../redux/actions/aCotizacion";
import {
  fetchCrearCarritoAccP,
  fetchRecuperarCarritoAccP,
  fetchObtenerPlanes,
  fetchListarProvinciasAP,
  fetchListarCiudadesAP,
  fetchObtenerPlanesAigmed
} from "../../redux/actions/aRamoAccidentesPersonales";
import LoadingScreen from "react-loading-screen";

import Select from "react-select";
import {
  Textbox,
  Textarea,
  Select as Select1,
  Select as Select2,
  Select as Select3,
  Checkbox
} from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import { ambienteAplicacion, urlProcesoApAbierto } from '../../constants/urls'
import { EquiRamos, ErrorMsgConstants } from "../../constants";
import { isDuplicateHogar } from "../../redux/actions/ACarritoProductos";
import Formulario from "../Generales/Formulario";

class CotizacionAccPersonal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      empresa: "",
      solicitante: "",
      ruc: "",
      cedula: "",
      idCarrito: "",
      hasEmpresaError: true,
      hasSolicitanteError: true,
      hasRucError: true,
      hasCedulaError: true,
      idAsesor: "",
      sucursalSeleccionada: "",
      loadingPaso: false,
      numPersonas: "",
      planes: [],
      planSeleccionado: "",
      nomPlanSeleccionado: "",
      subPlanSeleccionado: "",
      nomSubPlanSeleccionado: "",
      subPlan: false,
      subPlanes: [],
      subPlanId: "",
      subPlanNombre: "",
      hasPlanError: true,
      numMin: "",
      hasProvinciaError: true,
      hasCiudadError: true,
      provinciaSelected: "",
      ciudadSelected: "",
      arrayProvincias: [],
      arrayCiudades: [],
      direccionSelected: "",
      cargandoCiudades: false,
      hasSucursalError: true,
      numPersonasCampo1: 0,
      numPersonasCampo2: 0,
      labelNumPersonasCampo1: "",
      labelNumPersonasCampo2: "",
      hasnumPersonasError: true,
      hasnumPersonas2Error: true,
      mostrarmensajeNumPersonas: true,
      msgNumeroPersonas: '',
      arrayPreguntas: undefined,
      msgErrorPreguntas: undefined,
      verMsgErrorPreguntas: false,
      actividadSelected: "",
      arrayActividades: [],
      actividadHasError: true,
      msgConfirmarRecalculo: null,
      planesAigmed: [],
      planesAigmedError: false,
      planAigmedSeleccionado: null,
      mostrarAigmed: false
    };

    this.validateForm = this.validateForm.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  async validateForm(e) {
    const {
      cedula,
      ruc,
      empresa,
      solicitante,
      idCarrito,
      validate,
      loadingPaso,
      planSeleccionado,
      planAigmedSeleccionado,
      nomPlanSeleccionado,
      numMin,
      subPlanSeleccionado,
      nomSubPlanSeleccionado,
      hasDireccionError,
      hasCiudadError,
      direccionSelected,
      ciudadSelected,
      numPersonas,
      hasSucursalError,
      sucursalSeleccionada,
      arrayPreguntas
    } = this.state;

    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasEmpresaError,
      hasSolicitanteError,
      hasRucError,
      hasCedulaError,
      hasPlanError,
      numPersonasCampo1,
      numPersonasCampo2,
      hasnumPersonasError,
      hasnumPersonas2Error,
      actividadHasError,
      actividadSelected
    } = this.state;
    //Validar numero de personas

    let planesAigmedError = false
    let hasErrorNumeroPersonasValidacion = true
    let hasErrorResponderPreguntas = true
    let subplanValidador = true;
    if (this.state.planes && this.state.planSeleccionado) {
      let planElegido = this.state.planes.find(
        plan => plan.id === this.state.planSeleccionado
      );
      if (planElegido && (planElegido.numLabels === '2' || planElegido.numLabels === 2)) {
        if ((!hasnumPersonasError && !hasnumPersonas2Error) || (numPersonasCampo1 !== '' && numPersonasCampo2 !== '')) {
          if (parseInt(numPersonasCampo1) + parseInt(numPersonasCampo2) >= numMin) {
            hasErrorNumeroPersonasValidacion = false
          }
        }
      }
      else if (planElegido && (planElegido.numLabels === '1' || planElegido.numLabels === 1)) {
        if (!hasnumPersonasError && parseInt(numPersonasCampo1) >= numMin) {
          hasErrorNumeroPersonasValidacion = false
        }
      }
      //Validar que las preguntas han sido respondidas en caso que el plan tenga preguntas   

      if (this.state.planSeleccionado === "1015" && this.state.planAigmedSeleccionado == null) {
        planesAigmedError = true
      }

      if (planElegido && planElegido.preguntas) {
        let encontroError = false
        arrayPreguntas.forEach((element, i) => {
          if (element.opcionNo === false) {
            encontroError = true
          }
        });
        if (encontroError === false) {
          hasErrorResponderPreguntas = false
        }
        else {
          this.setState({
            verMsgErrorPreguntas: true
          })
        }
      }
      else {
        hasErrorResponderPreguntas = false
      }
      //validar si el seguro tiene subplan
      if (planElegido.banSubplan && planElegido.banSubplan === true) {
        if (subPlanSeleccionado === '') {
          subplanValidador = false
          this.toggleValidating(true);
        }
      }
    }

    // Llamar al servicio de validación de duplicidad de poliza
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",
      plataforma: 'WEB',
      identificacion: ruc,
      ramo: EquiRamos.ap,
    };
    console.log('checkDuplicidadObj pymes', checkDuplicidadObj,);
    await this.props.checkIsDuplicate({ type: 'otros', postObj: checkDuplicidadObj });


    // si es que no existe duplicidad, continuar
    if (!this.props.duplicity.isDuplicatePoliza) {
      // continuar si no hubo errores
      if (
        !hasEmpresaError &&
        !hasSolicitanteError &&
        !hasRucError &&
        !hasCedulaError &&
        !hasPlanError &&
        !hasErrorNumeroPersonasValidacion &&
        !hasErrorResponderPreguntas &&
        !hasSucursalError &&
        !this.props.duplicity.duplicidadPolizaError &&
        solicitante !== "" &&
        empresa !== "" &&
        cedula !== "" &&
        planSeleccionado !== "" &&
        numMin !== "" &&
        sucursalSeleccionada !== "" &&
        ruc !== "" &&
        !planesAigmedError &&
        subplanValidador &&
        !actividadHasError &&
        actividadSelected !== ''
      ) {
        this.setState({ loadingPaso: true });

        // console.log(planSeleccionado);
        // console.log(subPlanSeleccionado);
        // console.log(nomSubPlanSeleccionado);
        // console.log(nomSubPlanSeleccionado);


        var planAigEncontrado = this.state.planSeleccionado != "1015" ? "" : this.state.planesAigmed[this.state.planAigmedSeleccionado.value]


        let enviar = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          ambiente: "Desarrollo",
          sucursal: this.state.sucursalSeleccionada,
          empresaNombre: empresa,
          empresaRuc: ruc,
          solicitanteNombre: solicitante,
          solicitanteCedula: cedula,
          idAsesor: this.props.datosUsuarios.cliCodigoCore, //enviar el id del logueado
          pasoCarrito: "inicio",
          plan: {
            id: planSeleccionado,
            name: nomPlanSeleccionado
          },
          subplanes: {
            id: subPlanSeleccionado,
            name: nomSubPlanSeleccionado
          },
          provincia: this.state.provinciaSelected,
          ciudad: this.state.ciudadSelected,
          idCarrito: this.state.idCarrito ? this.state.idCarrito : "",
          direccion: this.state.direccionSelected,
          numPersonasTotal: numPersonasCampo1,
          numAdministrativos: numPersonasCampo2,
          objetoAsesor: {
            nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
            codigoCore: this.props.datosAsesor.cliCodigoCore,
            sucursalSeleccionada: this.state.sucursalSeleccionada,
            ambiente: ambienteAplicacion,
            emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
            brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
            brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
            brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
          },
          actividad: actividadSelected
        }
        if (this.state.planSeleccionado == "1015") {
          enviar.actividadAigmed = planAigEncontrado
        }
        console.log(JSON.stringify(enviar))
        await this.props.crearCarrito(enviar);

        if (!this.props.datosCarritoAcc.crearCarritoAccPError) {
          this.setState({
            idCarrito: this.props.datosCarritoAcc.productoAccP.mongoCarrito
          });
          console.log('test1 david');
          this.props.history.push({
            pathname: "/servicios-cotizacion-accidente-personal"
          });
        }
      } else {
        console.log("NO VALIDO");
      }
    }

  }

  async cambiarRucId(identificacion, tipo) {
    await this.props.consultarIdentificacion({
      empresa: "AIGMETROPOLITANA",
      identificador: identificacion,
      tipo: tipo
    });

    if (!this.props.datosIdentificacionAP.consultarIdentificacionAPhasError) {
      if (
        tipo === "ruc" &&
        this.props.datosIdentificacionAP.IdentificacionAP[0] !== undefined
      ) {
        this.setState({
          empresa: this.props.datosIdentificacionAP.IdentificacionAP[0].nombre,
          hasEmpresaError: false,
          validate: true
        });
      } else if (
        tipo === "cedula" &&
        this.props.datosIdentificacionAP.IdentificacionAP[0] !== undefined
      ) {
        this.setState({
          solicitante: this.props.datosIdentificacionAP.IdentificacionAP[0]
            .nombre,
          hasSolicitanteError: false,
          validate: true
        });
      }
    } else {
      if (tipo === "ruc") {
        this.setState({
          empresa: ""
        });
      } else if (tipo === "cedula") {
        this.setState({
          solicitante: ""
        });
      }
    }
  }

  async componentDidMount() {
    window.scroll(0, 0);

    //obtener sucursales
    await this.props.fethSucursales();

    //se obtiene provincias

    await this.props.obtenerProvincias("AIGMETROPOLITANA", "travel");

    if (!this.props.listaProvinciasAP.obtenerProviciasAPError) {

      let arrayProvincias = [];
      this.props.listaProvinciasAP.provinciasAP.map(p => {
        arrayProvincias.push({ value: p.provCodigoCore, label: p.label });
      });

      this.setState({
        arrayProvincias
      });

    }

    //se obtiene planes
    await this.props.obtenerPlanes({
      empresa: "AIGMETROPOLITANA",
      cotizador: "accidentesPersonales"
    });

    await this.props.obtenerPlanesAigmed()

    this.setState(
      {
        planesAigmed: this.props.listaPlanesAccP.planesAccPAigmed
      }
    )

    console.log('this.props.obtenerplanes before', this.props);
    if (!this.props.listaPlanesAccP.obtenerPlanesAccPhasError) {
      console.log('this.props.obtenerplanes afeter', this.props.listaPlanesAccP.planesAccPAigmed);
      this.setState({
        arrayActividades: this.props.listaPlanesAccP.planesCotizacionAccP.actividades ? this.props.listaPlanesAccP.planesCotizacionAccP.actividades : [],
        planes: this.props.listaPlanesAccP.planesCotizacionAccP.planes,
        numMin: parseInt(
          this.props.listaPlanesAccP.planesCotizacionAccP.minPersonasCotizar
        ),
        msgConfirmarRecalculo: this.props.listaPlanesAccP.planesCotizacionAccP.msgConfirmarRecalculo
      });
    }

    //se obtiene el id desde la url

    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get("id");

    if (idCarrito !== undefined && idCarrito !== null && idCarrito !== "") {
      await this.props.recuperarCarrito({
        empresa: "AIGMETROPOLITANA",
        idCarrito: idCarrito
      });

      const {
        datosContratanteEmpresa,
        datosContratantePersona,
        datosUbicacion,
        carProductos,
        carDatosAsesor
      } = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP;
      this.setState({
        empresa: datosContratanteEmpresa.cliRazonSocial,
        solicitante: datosContratantePersona.nombreCompleto,
        ruc: datosContratanteEmpresa.cliIdentificacion,
        cedula: datosContratantePersona.cliIdentificacion,
        idCarrito,
        hasEmpresaError: false,
        hasSolicitanteError: false,
        hasRucError: false,
        hasCedulaError: false,
        idAsesor: this.props.datosUsuarios.cliCodigoCore, //enviar el id del logueado
        sucursalSeleccionada: carDatosAsesor.sucursalSeleccionada,
        provinciaSelected: datosUbicacion.provincia,
        hasProvinciaError: datosUbicacion.provincia !== "" ? false : true,
        ciudadSelected: datosUbicacion.ciudad,
        hasCiudadError: datosUbicacion.ciudad !== "" ? false : true,
        direccionSelected: datosUbicacion.direccion,
        hasDireccionError: datosUbicacion.direccion !== "" ? false : true,
        planSeleccionado: carProductos[0].plan.id,
        subPlanSeleccionado: carProductos[0].subplanes.id,
        numPersonas: carProductos[0].numPersonasTotal,
        numPersonasCampo1: carProductos[0].numPersonasTotal,
        numPersonasCampo2: carProductos[0].numAdministrativos,
        hasnumPersonasError: carProductos[0].numPersonasTotal ? false : true,
        hasnumPersonas2Error: carProductos[0].numAdministrativos ? false : true,
        hasSucursalError: carDatosAsesor.sucursalSeleccionada ? false : true,
        actividadSelected: carProductos[0].actividad ? carProductos[0].actividad : '',
        actividadHasError: carProductos[0].actividad ? false : true,
      });


      //Marcar las preguntas        
      if (carProductos[0].respondioPreguntas && carProductos[0].respondioPreguntas === true) {
        const { arrayPreguntas } = this.state;
        let arrayPreguntasRespondidas = arrayPreguntas ? arrayPreguntas : undefined
        if (arrayPreguntasRespondidas && arrayPreguntasRespondidas !== undefined) {
          arrayPreguntasRespondidas.forEach((element, i) => {
            arrayPreguntasRespondidas[i] = { ...arrayPreguntasRespondidas[i], opcionSi: false, opcionNo: true }
          });
          this.setState({
            arrayPreguntas: arrayPreguntasRespondidas
          })
        }
      }

    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.empresa !== this.state.empresa) {
      if (this.state.empresa !== "") {
        this.setState({ hasEmpresaError: false });
      } else {
        this.setState({ hasEmpresaError: true });
      }
    }

    if (prevState.solicitante !== this.state.solicitante) {
      if (this.state.solicitante !== "") {
        this.setState({ hasSolicitanteError: false });
      } else {
        this.setState({ hasSolicitanteError: true });
      }
    }

    if (prevState.planSeleccionado !== this.state.planSeleccionado) {
      if (this.state.planSeleccionado !== "") {
        this.setState({ hasPlanError: false });

        let ListaPlanes = this.state.planes;
        let planActual = this.state.planSeleccionado;

        //let approved = ListaPlanes.filter(plan => plan.id = 1013);        
        let planElegido = ListaPlanes.find(
          plan => plan.id === planActual
        );
        //mensaje numero de personas
        let msgnumper = `El número total de personas ingresadas debe ser mínimo ${this.state.numMin}`
        if (planElegido.numLabels && (planElegido.numLabels === '2' || planElegido.numLabels === 2)) {
          msgnumper = `El número de personas ingresadas entre los campos (${planElegido.label1}) y (${planElegido.label2}) debe ser mínimo ${this.state.numMin}`
        }
        //Validar si el plan seleccionado tiene preguntas
        let arraypreguntasValor = undefined
        let msgErrorPreguntasValor = undefined
        let verMsgErrorPreguntasValor = false
        if (planElegido.preguntas) {
          arraypreguntasValor = planElegido.preguntas
          arraypreguntasValor.forEach((element, i) => {
            arraypreguntasValor[i] = { ...arraypreguntasValor[i], opcionSi: false, opcionNo: false }
          });
          if (planElegido.mensajeErrorPreguntas) {
            msgErrorPreguntasValor = planElegido.mensajeErrorPreguntas
          }
        }
        await this.setState({
          nomPlanSeleccionado: planElegido.name,
          subPlan: planElegido.banSubplan,
          subPlanes: planElegido.banSubplan ? planElegido.subPlanes : [],
          labelNumPersonasCampo1: planElegido.label1 ? planElegido.label1 : '',
          labelNumPersonasCampo2: planElegido.label2 ? planElegido.label2 : '',
          msgNumeroPersonas: msgnumper,
          arrayPreguntas: arraypreguntasValor,
          msgErrorPreguntas: msgErrorPreguntasValor,
          verMsgErrorPreguntas: verMsgErrorPreguntasValor
        });
      }
      else {
        await this.setState({
          numPersonasCampo1: 0,
          numPersonasCampo2: 0,
          labelNumPersonasCampo1: "",
          labelNumPersonasCampo2: "",
          hasnumPersonasError: true,
          hasnumPersonas2Error: true,
          mostrarmensajeNumPersonas: true,
          msgNumeroPersonas: '',
          arrayPreguntas: undefined,
          verMsgErrorPreguntas: false
        });
      }
    }

    if (prevState.subPlanSeleccionado !== this.state.subPlanSeleccionado) {
      if (this.state.subPlanSeleccionado !== "") {
        let ListaPlanes = this.state.subPlanes;
        let planActual = this.state.subPlanSeleccionado;

        //let approved = ListaPlanes.filter(plan => plan.id = 1013);
        let subPlanElegido = ListaPlanes.find(plan => plan.id === planActual);

        this.setState({
          nomSubPlanSeleccionado:
            subPlanElegido && subPlanElegido.name
              ? subPlanElegido.name
              : this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
                .carProductos[0].subplanes.name
        });
      }
    }

    if (prevState.provinciaSelected !== this.state.provinciaSelected) {
      if (this.state.provinciaSelected !== "") {
        //se manda a listar las provincias
        await this.props.obtenerCiudades({
          empresa: "AIGMETROPOLITANA",
          codProvincia: this.state.provinciaSelected.value,
          ramo: "travel"
        });

        console.log(
          "lista ciudades",
          this.state.provinciaSelected.value,
          "-",
          this.props.listaCiudadesAP
        );

        if (
          this.props.listaCiudadesAP &&
          !this.props.listaCiudadesAP.obtenerCiudadesAPError &&
          this.props.listaCiudadesAP.ciudadesAP
        ) {
          this.setState({
            arrayCiudades: this.props.listaCiudadesAP.ciudadesAP.ciudades
          });
        }
      } else {
        this.setState({ hasProvinciaError: true });
      }
    }
  }

  render() {
    let arraySucursales = [];
    this.props.sucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });

    arraySucursales.unshift({ id: "", name: "Seleccione una opción" });

    let arrayProvincias = this.state.arrayProvincias;
    let arrayCiudades = this.state.arrayCiudades;
    const {
      validate,
      empresa,
      solicitante,
      ruc,
      cedula,
      loadingPaso,
      numPersonas,
      planSeleccionado,
      planAigmedSeleccionado,
      subPlanSeleccionado,
      numMin,
      subPlan,
      subPlanes,
      provinciaSelected,
      hasProvinciaError,
      hasCiudadError,
      ciudadSelected,
      direccionSelected,
      cargandoCiudades,
      sucursalSeleccionada,
      numPersonasCampo1,
      numPersonasCampo2,
      labelNumPersonasCampo1,
      labelNumPersonasCampo2,
      mostrarmensajeNumPersonas,
      msgNumeroPersonas,
      arrayPreguntas,
      verMsgErrorPreguntas,
      msgErrorPreguntas,
      arrayActividades,
      actividadSelected,
      actividadHasError
    } = this.state;

    let arrayPlanes = this.state.planes;

    let nuevoArray = []

    this.state.planesAigmed.forEach((plan, index) => {
      const aux = { value: index, label: plan.value }
      nuevoArray.push(aux)
    });

    let arrayPlanesAigmed = nuevoArray;

    console.log('estios ssad: ', arrayActividades)

    const guardarInformacion = async (values) => {
      var url = `${urlProcesoApAbierto}`;
      const body = {
        "empresa": "AIGMETROPOLITANA",
        "plataforma": "WEB",
        "ambiente": "Desarrollo",
        "sucursal": values.sucursal.value,
        "empresaNombre": values.nombreEmpresa,
        "empresaRuc": values.ruc,
        "solicitanteNombre": values.nombreSolicitante,
        "solicitanteCedula": values.cedulaSolicitante,
        "idAsesor": this.props.datosUsuarios.cliCodigoCore,
        "pasoCarrito": "inicio",
        "provincia": values.provincia,
        "ciudad": values.ciudad,
        "idCarrito": "",
        "direccion": values.direccion,
        "numeroPersonas": 5,
        "objetoAsesor": {
          nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
          codigoCore: this.props.datosAsesor.cliCodigoCore,
          sucursalSeleccionada: values.sucursal.value,
          ambiente: ambienteAplicacion,
          emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
          brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
          brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
          brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
        },
        "actividad": values.actividadEmpresa
      }
      console.log('verUrl', url, values, body)
      try {
        const response = await fetch(url, { body: JSON.stringify(body), method: 'POST' })
        const json = await response.json()
        console.log('verUrl', json)
        if (json.transaccion) {
          this.props.history.push({
            pathname: "/cotizacion-accidente-personal-abierto-categoria",
            search: `?id=${json.idCarrito}`, //agregar parametros de la url,
          });
        }
        console.log('verUrl', json)
      } catch (error) {
        console.log('verUrl', error)
      }
    }


    let arraySubplanes = this.state.subPlanes;

    let isLoading =
      this.props.datosIdentificacionAP.consultarIdentificacionAPIsLoading ===
        undefined
        ? false
        : this.props.datosIdentificacionAP.consultarIdentificacionAPIsLoading;
    return (
      <LoadingScreen
        loading={
          isLoading ||
          loadingPaso ||
          this.props.listaProvinciasAP.obtenerProvinciasLoading ||
          this.props.listaPlanesAccP.obtenerPlanesAccPIsLoading ||
          this.props.datosRecuperarCarritoAccP.recuperarCarritoAccPIsLoading ||
          this.props.duplicity.duplicidadPolizaLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        <Page
          title="Cotización Accidentes Personales Abierto"
          breadcrumbs={[{ name: "Cotización Accidentes", active: true }]}
        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>

          <Formulario
            codigoFormulario={'formulario-inicial-ap-abierto'}
            onSubmit={(values, tieneErrores, errores) => {
              if (!tieneErrores) {
                guardarInformacion(values)

              }
            }}

            onChange={(values) => {

            }}
          />


        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosIdentificacionAP: state.datosIdentificacionAP,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
  listaPlanesAccP: state.listaPlanesAccP,
  listaProvinciasAP: state.listaProvinciasAP,
  listaCiudadesAP: state.listaCiudadesAP,
  datosCarritoAcc: state.datosCarritoAccP,
  sucursales: state.datosSucursales.DataSucursales,
  datosAsesor: state.datosUsuarios.dataUsuario,
  duplicity: state.datosDuplicidadPolizas,
});

const mapDispatchToProps = dispatch => {
  return {
    consultarIdentificacion: datos =>
      dispatch(fetchConsultarIdentificacionAP(datos)),
    crearCarrito: datos => dispatch(fetchCrearCarritoAccP(datos)),
    recuperarCarrito: datos => dispatch(fetchRecuperarCarritoAccP(datos)),
    obtenerPlanes: datos => dispatch(fetchObtenerPlanes(datos)),
    obtenerPlanesAigmed: datos => dispatch(fetchObtenerPlanesAigmed()),
    obtenerProvincias: (empresa, ramo) =>
      dispatch(fetchListarProvinciasAP(empresa, ramo)),
    obtenerCiudades: datos => dispatch(fetchListarCiudadesAP(datos)),
    fethSucursales: () => dispatch(sucursalesFetch()),
    checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionAccPersonal)
);
